import React from 'react';
import bannerImageDefault from '../../assets/images/default/event-image.jpg';
import icon4 from '../../assets/images/small/megaphone-dark.png';
import icon2 from '../../assets/images/small/megaphone.png';
import icon3 from '../../assets/images/small/percentage-red.png';
import icon5 from '../../assets/images/small/percentage-yellow.png';
import calendarIcon from '../../assets/light_theme_images/Calendar-Clock-light.svg';
import locationLightIcon from '../../assets/light_theme_images/location-light.svg';
import offerLightIcon from '../../assets/light_theme_images/offer-light-icon.svg';
import { convertToAmPm, convertToDate } from '../../common/commonFunction';
import { Link } from 'react-router-dom';
import withRouter from '../Common/withRouter';
import { pushViewEvent } from '../../seo/gtevents';

const EventView = ({ singleEvent, props, section_title }) => {
  return (
    <>
      <div key={singleEvent.id}>
        <div className="relative group">
          <img
            src={
              singleEvent.banner_image
                ? singleEvent.banner_image
                : bannerImageDefault
            }
            alt=""
            className="w-full aspect-[9/16] object-fill rounded-lg"
            onClick={() => {
              const category =
                section_title === 'Popular Events Near You'
                  ? 'Popular Events'
                  : section_title === 'Events With Exclusive Offers'
                    ? 'Exclusive Offer Events'
                    : section_title === 'Upcoming Events Near You'
                      ? 'Upcoming Events'
                      : 'Other Events';
              pushViewEvent('View Event', category, 'View Event', singleEvent);
            }}
          />
          <div className="absolute bottom-0 left-0 right-0 w-full duration-1000 ease-in-out lg:hidden group-hover:block">
            <div
              className="bg-[#101010] rounded-b-lg py-[6px] md:py-2 lg:py-[14px] px-1 md:px-2 lg:px-4 pass-border-liner-gradient"
              onClick={() => {
                const category =
                  section_title === 'Popular Events Near You'
                    ? 'Popular Events'
                    : section_title === 'Events With Exclusive Offers'
                      ? 'Exclusive Offer Events'
                      : section_title === 'Upcoming Events Near You'
                        ? 'Upcoming Events'
                        : 'Other Events';
                pushViewEvent(
                  'View Event',
                  category,
                  'View Event',
                  singleEvent,
                );
              }}
            >

              {singleEvent.dates && singleEvent.dates[0] ? (
                <p className="text-white text-[12px] lg:text-[14px] font-normal ">
                  <img
                    src={calendarIcon}
                    alt="location"
                    className="inline-block mr-[3px] md:mr-2 size-[14px] md:size-6 -mt-[2px]"
                  />
                  {singleEvent.dates && singleEvent.dates[0]
                    ? singleEvent.dates[0]['date'] &&
                    convertToDate(singleEvent.dates[0]['date'])
                    : ''}
                  {singleEvent &&
                    singleEvent.dates &&
                    singleEvent.dates[0] &&
                    singleEvent.dates[0]['start_time']
                    ? ' | '
                    : ''}
                  {singleEvent &&
                    singleEvent.dates &&
                    singleEvent.dates[0] &&
                    singleEvent.dates[0]['start_time']
                    ? convertToAmPm(singleEvent.dates[0]['start_time'])
                    : ''}
                </p>
              ) : (
                ''
              )}
              {singleEvent.dates &&
                singleEvent.dates[0] &&
                singleEvent.dates[0]['address'] ? (
                <p className="text-white text-[12px] lg:text-[14px] font-normal mt-1 ">
                  <img
                    src={locationLightIcon}
                    alt="location"
                    className="inline-block mr-[3px] md:mr-2 size-[14px] md:size-6"
                  />
                  {singleEvent.dates[0]['address']}
                </p>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
        <h3 className="text-base md:text-md font-semibold text-[#101010] leading-6 md:leading-9 mt-2 xl:mt-3">{singleEvent.name}</h3>
      </div>
    </>
  );
};

export default withRouter(EventView);
